import React from 'react';
import Card from '../../styled/Card/Card';
import EditorForm from '../EditorForm/EditorForm';
import EditorView from '../EditorView/EditorView';
import { EditorWrapper, EditorInner } from './Editor.styles';

interface EditorProps {}

const Editor: React.FC<EditorProps> = () => (
  <EditorWrapper>
    <EditorInner>
      <EditorView />
      <EditorForm />
    </EditorInner>
  </EditorWrapper>
);

export default Editor;
